import { Plat_isAndroid } from '../Plat/Plat.device'

export async function hideSafariViewController() {
    if (window.SafariViewController == null) return
    if (Plat_isAndroid()) {
        // SafariViewController.hide will always throw on android
        // https://github.com/EddyVerbruggen/cordova-plugin-safariviewcontroller/issues/62
        return
    }
    return new Promise<void>((resolve, reject) => window.SafariViewController.hide(resolve, reject))
}

export async function showSafariViewController(url: string) {
    if (window.SafariViewController == null) return
    return new Promise<void>((resolve, reject) => window.SafariViewController.show({ url }, () => resolve(), reject))
}

export function safariViewControllerAvailable() {
    if (!window.SafariViewController) {
        return Promise.resolve(false)
    }
    return new Promise<boolean>((resolve) => window.SafariViewController.isAvailable(resolve))
}
